// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pSup9","card-header":"Card_card-header__5yht5","card-header-title":"Card_card-header-title__O2aqV","card-body":"Card_card-body__NeyrD"};